import { useTranslation } from "react-i18next";
import { useState } from "react";
import LanguageSwitcher from "./language-switcher";
import { useDetectLanguage } from "../helpers/language-detector";
import logo from "../../images/logos/logo.png";
import logoExtendedKa from "../../images/logos/logo-extended-ka.png";
import logoExtendedEn from "../../images/logos/logo-extended-en.png";

const navItems = [
    { id: "home", url: "" },
    { id: "news", url: "/news" },
    {
        id: "church",
        children: [
            { id: "history", url: "/church/history" },
            { id: "patriarch", url: "/church/patriarch" },
            { id: "synod", url: "/church/synod" },
        ],
    },
    {
        id: "diocese",
        children: [
            { id: "history", url: "/diocese/history" },
            { id: "bishop", url: "/diocese/bishop" },
            { id: "parishes", url: "/diocese/parishes" },
            { id: "monasteries", url: "/diocese/monasteries" },
            { id: "clergy", url: "/diocese/clergy" },
            { id: "archpriests", url: "/diocese/archpriests" },
            { id: "metropolitanates", url: "/diocese/metropolitanates" },
            { id: "chancellery", url: "/diocese/chancellery" },
            { id: "admin_council", url: "/diocese/admin-council" },
            { id: "board", url: "/diocese/board" },
            { id: "court", url: "/diocese/court" },
            { id: "documents", url: "/diocese/documents" },
        ],
    },
    { id: "contact", url: "/contact" },
    // { id: "donate", url: "/donate", special: true },
];

export default function Navbar() {
    const { t } = useTranslation();
    const lang = useDetectLanguage();

    const [menuOpen, setMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const toggleMenu = () => setMenuOpen((prev) => !prev);

    const toggleDropdown = (id) => {
        setOpenDropdown((prev) => (prev === id ? null : id));
    };

    const renderNavItem = (item) => {
        const isDropdown = item.children !== undefined;
        const isOpen = openDropdown === item.id;

        return (
            <li
                key={item.id}
                id={item.id}
                className={`nav-item ${isDropdown ? "dropdown" : ""} ${
                    isOpen ? "unfold" : ""
                } ${item.special ? "special" : ""}`}
            >
                {isDropdown ? (
                    <>
                        <a
                            className="nav-link"
                            onClick={(e) => {
                                if (window.innerWidth <= 1200) {
                                    e.preventDefault(); // prevent navigation on mobile
                                    toggleDropdown(item.id);
                                }
                            }}
                        >
                            {t(`nav.${item.id}.label`)} <i className="bi bi-caret-down-fill"></i>
                        </a>
                        <ul className="dropdown-menu">
                            {item.children.map((child) => (
                                <li key={child.id} id={child.id}>
                                    <a href={`${child.url}/?lang=${lang}`} className="nav-link">
                                        {t(`nav.${item.id}.${child.id}`)}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </>
                ) : (
                    <a href={`${item.url}/?lang=${lang}`} className="nav-link">
                        {t(`nav.${item.id}`)}
                    </a>
                )}
            </li>
        );
    };

    return (
        <nav className="navbar">
            <div className="navbar-brand">
                <a href={`/?lang=${lang}`}>
                    <img src={lang === "ka" ? logoExtendedKa : logoExtendedEn} alt="Logo" />
                </a>
            </div>

            <div className="navbar-toggler" onClick={toggleMenu}>
                <i className={`bi ${menuOpen ? "bi-x" : "bi-list"}`}></i>
            </div>

            <ul className={`navbar-menu ${menuOpen ? "slide" : ""}`}>
                <a href={`/?lang=${lang}`} className="navbar-menu-logo">
                    <img src={logo} alt="GAOCNA" />
                </a>
                {navItems.map(renderNavItem)}
                <li className="nav-item translate">
                    <LanguageSwitcher />
                </li>
            </ul>
        </nav>
    );
}
